import { DatePipe } from '@angular/common';
import { Column, GridRow } from '@shared';
class ChangesetSummary {
    tierId?: number;
    @Column({
        title: 'Tier',
        field: 'tierName',
        order: 0.1,
        width: 150,
        filterable: true,
        filterType: 'custom',
        type: 'string',
        sortable: true,
        visibleInQuickView: true,
    })
    tierName: string = '';


  @Column({
    title: 'Transaction Date',
    field: 'transactionDate',
    order: 0.4,
    width: 100,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd', '+0000'],
    filterable: true,
    filterType: 'date',
    type: 'string',
    sortable: true,
    hidden: true,
    visibleInQuickView: true,
  })
  transactionDate: Date | null = null;

  @Column({
    title: 'Scheduled For',
    field: 'scheduledDate',
    order: 0.4,
    width: 100,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd'],
    filterable: true,
    filterType: 'date',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
  })
  scheduledDate: Date | null = null;

  @Column({
    title: 'Sent On',
    field: 'transmittedDate',
    order: 0.5,
    width: 80,
    filterable: true,
    filterType: 'date',
    type: 'string',
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd'],
    sortable: true,
    visibleInQuickView: true,
  })
  transmittedDate: Date | null = null;

  @Column({
    title: 'Type',
    field: 'syncType',
    order: 0.2,
    width: 80,
    filterable: false,
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  syncType: string[] = [];

  @Column({
    title: 'Submitted By',
    field: 'submittedBy',
    order: 0.1,
    width: 80,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    visibleInQuickView: true,
  })
  submittedBy: string | null = null;

  changesetCount: number = 0;

  @Column({
    title: 'Restaurants',
    field: 'restaurantCount',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    visibleInQuickView: true,
  })
  restaurantCount: number = 0;

  
  @Column({
    title: 'Failed',
    field: 'failedCount',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    visibleInQuickView: true,
  })
  failedCount: number = 0;



  @Column({
    title: 'Pending',
    field: 'pendingCount',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    visibleInQuickView: true,
  })
  pendingCount: number = 0;


    @Column({
    title: 'Success',
    field: 'successCount',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    visibleInQuickView: true,
  })
  successCount: number = 0;


    @Column({
        title: 'Cancelled',
        field: 'canceledCount',
        order: 8,
        width: 80,
        filterable: true,
        filterType: 'numeric',
        type: 'number',
        visibleInQuickView: true,
    })
    canceledCount: number = 0;

  constructor(changesetSummary?: Partial<ChangesetSummary>) {
      Object.assign(this, changesetSummary);
  }
}
export class GridRowChangesetSummary extends GridRow(ChangesetSummary) {}
